import React, { FC, createContext, useState, useMemo } from 'react';

interface ISignInFastTrack {
  email: string;
}

interface IGlobalContext {
  signInFastTrack: ISignInFastTrack | null;
  setSignInFastTrack: (value: ISignInFastTrack | null) => void;
}

export const GlobalContext = createContext<IGlobalContext>({
  signInFastTrack: null,
  setSignInFastTrack: () => undefined,
});

export const GlobalContextContainer: FC = ({ children }) => {
  const [signInFastTrack, setSignInFastTrack] = useState<ISignInFastTrack | null>(null);

  const contextValue = useMemo(
    () => ({
      signInFastTrack,
      setSignInFastTrack,
    }),
    [signInFastTrack]
  );

  return <GlobalContext.Provider value={contextValue}>{children}</GlobalContext.Provider>;
};
